'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGates = undefined;

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _getWidgetData = require('./getWidgetData');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getGates = exports.getGates = (0, _reselect.createSelector)([_getWidgetData.getWidgetData], (0, _get2.default)('gates'));


//////////////////
// WEBPACK FOOTER
// ./js/selectors/widgetDataSelectors/getGates.js
// module id = 629
// module chunks = 2 3